import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import BranchHierarchy from '../model/BranchHierarchy';
import Immutable from 'immutable';

const emptyUser = {
  roles: [],
  settings: {
    favorites: []
  },
  timezone: 7
};

const defaultState = {
  user: emptyUser,
  authenticated: false,
  selectedClient: {
    key: 'unknown',
    name: 'unknown'
  },
  clientInfo: {},
  roles: []
};

function getUserInfo(store, defaultValue, transform) {
  const user = store.get('user');

  if (user) {
    return transform(user);
  } else {
    return defaultValue;
  }
}

class PortalUserStore extends ImmutableStore {
  static storeName = 'PortalUserStore';

  static handlers = {
    [Actions.AUTHENTICATION__CHECK_COMPLETED]: 'handleAuthentication',
    [Actions.AUTHENTICATION__COMPLETED]: 'handleAuthentication',
    [Actions.AUTHENTICATION__LOGOUT_COMPLETED]: 'handleAuthentication'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  handleAuthentication(
    {
      authenticated,
      user = {
        clients: {}
      },
      selectedClient,
      clientInfo
    } = {
      authenticated: false,
      user: emptyUser
    }
  ) {
    console.info('user information updated', {
      user,
      authenticated,
      selectedClient,
      clientInfo
    });
    if (authenticated) {
      const roles = Immutable.Set(user.roles);
      user.timezone = (12 - (new Date()).getTimezoneOffset()/60);
      this.setState({
        authenticated: true,
        user,
        selectedClient,
        roles,
        clientInfo
      });
    } else {
      this.setState({
        user: emptyUser,
        authenticated: false
      });
    }
  }

  getUserId() {
    return getUserInfo(this, null, user => {
      return user.get('id');
    });
  }

  getName() {
    return getUserInfo(this, '', user => {
      return user.get('firstName') + ' ' + user.get('lastName');
    });
  }

  getFirstName() {
    return getUserInfo(this, '', user => {
      return user.get('firstName');
    });
  }

  getLastName() {
    return getUserInfo(this, '', user => {
      return user.get('lastName');
    });
  }

  getBranchHierarchyTerms = () => {
    return this.get(['clientInfo', 'branchHierarchyTerms']);
  };

  _getUserAccessibleBranchHierarchySelections = () => {
    const selectedBranchHierarchy = this.get(['user', 'settings', 'selectedBranchHierarchy']);
    return this.userLoggedIn() && selectedBranchHierarchy ? selectedBranchHierarchy : Immutable.List();
  };

  getUserAccessibleBranchHierarchy = () => {
    const userAccessibleBranchHierarchySelections = this._getUserAccessibleBranchHierarchySelections();
    const clientBranchHierarchyTerms = this.getBranchHierarchyTerms();
    const clientBranchHierarchy = this.get(['clientInfo', 'branchHierarchy']);
    const branchHierarchy = new BranchHierarchy(clientBranchHierarchyTerms, clientBranchHierarchy);
    return branchHierarchy.filteredBranchHierarchy(userAccessibleBranchHierarchySelections);
  };

  getEmailAddress() {
    return getUserInfo(this, '', user => {
      return user.get('emailAddress');
    });
  }

  getTitle() {
    return getUserInfo(this, 'Consultant', user => {
      return user.getIn(['settings', 'title']);
    });
  }

  userHasRole(role) {
    const currentRoles = this.get('roles') || Immutable.Set();
    return this.userLoggedIn() && currentRoles.contains(role) || currentRoles.contains('root');
  }

  getSelectedClient() {
    return (this.get(['selectedClient']) || Immutable.Map()).toJS();
  }

  getClientName() {
    return this.get(['selectedClient', 'name']);
  }

  userLoggedIn() {
    return this.get('authenticated') || false;
  }

  getRoles() {
    return (this.get('roles') || Immutable.Seq()).toJS();
  }

  getEnabledClients() {
    return this.userLoggedIn() ? (this.get(['user', 'settings', 'enabledClients']) || Immutable.Seq()).toJS() : [];
  }
}

export default PortalUserStore;



// WEBPACK FOOTER //
// ./src/stores/PortalUserStore.js